import React from 'react';

// Styles & Assets
import styles from './ScoreTableParams.module.css';

// Services
import { getPuntuationsFromScore } from '../../../services/Scores';

// Hooks
import useTranslate from '../../../hooks/useTranslate';
import { useTranslation } from 'react-i18next';

// Interfaces
import { ScoreParameter, ScoreParameterSheet } from '../../../interfaces/Score';
import { Parameter } from '../../../interfaces/Profile';
interface Props {
    scoreParameters: ScoreParameterSheet[]
}

const ScoreTableParams: React.FC<Props> = ({ scoreParameters }) => {

    const { t } = useTranslation();

    const { translateMiddleware } = useTranslate();

    const puntuations = getPuntuationsFromScore(scoreParameters);

    const classColorCell = (level: number | undefined) => {
        if (level === undefined) return;
        const valAbs = Math.abs(level);
        if (valAbs === 0) return styles.value0;
        if (valAbs === 1) return styles.value1;
        if (valAbs === 2) return styles.value2;
        return styles.value3;
    };

    const parseRanges = (sheet_parameter_option_id: ScoreParameterSheet['sheet_parameter_option_id'], param: ScoreParameter) => {
        if ((param.value_min_range === null || param.value_min_range.trim() === '') && param.value_max_range !== null) return `≤${param.value_max_range}`;
        else if (param.value_min_range !== null && (param.value_max_range === null || param.value_max_range.trim() === '')) return `≥${param.value_min_range}`;
        else if (param.value_min_range !== null && param.value_max_range !== null) return `${param.value_min_range} - ${param.value_max_range}`;
        else if (sheet_parameter_option_id !== null) return sheet_parameter_option_id;
        return '';
    };

    const getParamName = (param: Parameter) => {
        if (!param.name_translations) return param.name;
        return translateMiddleware(param.name_translations)?.text ?? param.name;
    };


    return (
        <table className={styles.tableParameters}>
            <thead className={styles.tableHead}>
                <tr >
                    <th className={styles.headElement}>{t('parameters')}</th>
                    {puntuations.map(puntuation =>
                        <th key={puntuation} className={`${styles.textCenter} ${styles.headElement}`}>
                            {Math.abs(puntuation)}
                        </th>
                    )}
                </tr>
            </thead>
            <tbody>
                {scoreParameters.map(sheetParam =>
                    <tr key={sheetParam.sheet_parameter_id}>
                        <td className={styles.bodyElement}>{getParamName(sheetParam.sheet_parameter) ?? sheetParam.sheet_parameter_id}</td>
                        {puntuations.map(puntuation => {
                            const param = sheetParam.parameters.find(parameter => parameter.puntuation === puntuation);
                            return (
                                <td key={puntuation} className={`${styles.bodyElement} ${styles.textCenter} 
                                                ${classColorCell(puntuation)}`}>
                                    {param ? parseRanges(sheetParam.sheet_parameter_option_id, param) : null}
                                </td>
                            );
                        })}
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default ScoreTableParams;